interface CheckUserSegmentsProps {
  product?: {
    applicable_brand_specials_excluded_user_segments?: number[] | -1 | null;
    applicable_brand_specials_included_user_segments?: number[] | -1 | null;
  };
  store?: {
    id?: string | number;
    state?: string | null;
  };
  userSegments: number[];
}

interface ShouldSeeSpecialProps {
  excludedSegments?: number[] | -1 | null;
  includedSegments?: number[] | -1 | null;
  userSegments?: number[];
}

export const shouldShowSpecial = ({
  excludedSegments,
  includedSegments,
  userSegments = [],
}: ShouldSeeSpecialProps): boolean => {
  const noIncludedSegments =
    !includedSegments || includedSegments === -1 || !includedSegments.length;
  const noExcludedSegments =
    !excludedSegments || excludedSegments === -1 || !excludedSegments.length;

  if (!userSegments || userSegments.length === 0) {
    // If the user has no segments, they can't see
    // specials that have any inclusion segments
    return noIncludedSegments;
  }

  const userIsIncluded = noIncludedSegments
    ? true
    : userSegments.some((segmentId) => includedSegments?.includes(segmentId));

  const userIsExcluded = noExcludedSegments
    ? false
    : userSegments.some((segmentId) => excludedSegments?.includes(segmentId));

  return userIsIncluded && !userIsExcluded;
};

export const checkUserSegments = ({
  product,
  userSegments,
}: CheckUserSegmentsProps): boolean => {
  if (product) {
    const includedSegments =
      product.applicable_brand_specials_included_user_segments;
    const excludedSegments =
      product.applicable_brand_specials_excluded_user_segments;

    return shouldShowSpecial({
      excludedSegments,
      includedSegments,
      userSegments,
    });
  }

  return true;
};

export const checkLocationAndStoreId = (
  goldConfig: number[],
  store?: {
    id: number;
  }
): boolean => {
  const id = store?.id;

  if (id) {
    return goldConfig.includes(Number(id));
  }

  return false;
};
